module.exports = __webpack_public_path__ + "img/michael-wollny.82b76276.jpg";